var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentSendButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0507812,
    y: 0.173828,
    width: 61.2,
    height: 39.299,
    rx: 9,
    fill: "#143950"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3868 28.0761C22.9736 28.244 22.5811 28.207 22.2092 27.9653C21.8373 27.7245 21.6514 27.3733 21.6514 26.9117V22.2226C21.6514 21.9289 21.734 21.6666 21.8993 21.4359C22.0646 21.2051 22.2918 21.0582 22.5811 20.9953L31.5682 18.7294L22.5811 16.4635C22.2918 16.4006 22.0646 16.2537 21.8993 16.0229C21.734 15.7922 21.6514 15.5299 21.6514 15.2362V10.5471C21.6514 10.0855 21.8373 9.7339 22.2092 9.49221C22.5811 9.25135 22.9736 9.21485 23.3868 9.38269L42.4766 17.565C42.9931 17.7958 43.2514 18.1839 43.2514 18.7294C43.2514 19.2749 42.9931 19.663 42.4766 19.8938L23.3868 28.0761Z",
    fill: "#A3DAE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSendButton);
export default __webpack_public_path__ + "static/media/commentSendButton.dd63d88bde16240ac9a1486b380b0f12.svg";
export { ForwardRef as ReactComponent };